import apiClient from '../api/client';

export const chatService = {
    sendMessage: async (message) => {
        try {
            const response = await apiClient.post(
                `/api/v1/chatbot/session/ask?question=${encodeURIComponent(message)}`,
                null,
            );
            return response.data;
        } catch (error) {
            console.error('Error sending message:', error);
            throw error;
        }
    },

    sendMessageWithDocument: async (message, file, broker = null) => {
        try {
            const formData = new FormData();
            formData.append('question', message);
            formData.append('file', file);
            if (broker) {
                formData.append('broker', broker);
            }

            const response = await apiClient.post(
                `/api/v1/chatbot/session/ask-with-document?question=${encodeURIComponent(message)}`,
                formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' },
                    timeout: 120000,
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error sending message with document:', error);
            throw error;
        }
    }
};

export default chatService;
